/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type RemovableItem_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type RemovableItems_organization$ref: FragmentReference;
declare export opaque type RemovableItems_organization$fragmentType: RemovableItems_organization$ref;
export type RemovableItems_organization = {|
  +$fragmentRefs: RemovableItem_organization$ref,
  +$refType: RemovableItems_organization$ref,
|};
export type RemovableItems_organization$data = RemovableItems_organization;
export type RemovableItems_organization$key = {
  +$data?: RemovableItems_organization$data,
  +$fragmentRefs: RemovableItems_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RemovableItems_organization",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RemovableItem_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '13dcbb3550ba0c7f71c1e1d98c690c1c';

module.exports = node;
